import React, { useState, useMemo } from 'react';
import { Box, Button, useTheme, useMediaQuery, Typography } from '@mui/material';
import ProdutoAccordionList from './ProdutoAccordionList';
import ProdutoSelectorDialog from './ProdutoSelectorDialog';
import DialogConfirmacao from './DialogConfirmacao';
import AddIcon from '@mui/icons-material/Add';
import { useFieldValue } from 'components/form/input/NestedField';
import { useTranslation } from 'react-i18next';


// Agrupamento e ordenação
const agruparPorGrupo = (lista) =>
  Object.entries(
    (lista || []).reduce((acc, detalhamento) => {
      const grupoNome = detalhamento.produto.grupo?.nome || 'Sem Grupo';
      if (!acc[grupoNome]) acc[grupoNome] = [];
      acc[grupoNome].push({ ...detalhamento, indexList: lista.indexOf(detalhamento) });
      return acc;
    }, {})
  ).sort(([a], [b]) => a.localeCompare(b, 'pt-BR'));

export default function ProdutoSelector({ label, name, produtosPermitidos, permiteEditarDescricao, exibeLimpar }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [produtosSelecionados, setProdutosSelecionados] = useFieldValue(name)
  const [openDialog, setOpenDialog] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({ open: false, tipo: null, alvo: null });


  // Filtro e agrupamentos memorizados para evitar recalculo
  const produtosAgrupados = useMemo(
    () => agruparPorGrupo(produtosSelecionados),
    [produtosSelecionados]
  );

  const adicionarProdutos = (detalhamentos) => {
    const novos = detalhamentos.filter(
      (d) => !(produtosSelecionados || []).some((p) => p.produto.uid === d.produto.uid)
    );
    const atualizados = [...(produtosSelecionados || []), ...novos];
    setProdutosSelecionados(atualizados);

  };

  const removerProduto = (uid) => {
    const atualizados = produtosSelecionados.filter((p) => p.produto.uid !== uid);
    setProdutosSelecionados(atualizados);

  };

  const removerTodosDoGrupo = (grupoNome) => {
    const atualizados = produtosSelecionados.filter(
      (p) => (p.produto.grupo?.nome || 'Sem Grupo') !== grupoNome
    );
    setProdutosSelecionados(atualizados);

  };

  // Exclusão/diálogo
  const handleRemoveProductRequest = (detalhamento) => setConfirmDialog({ open: true, tipo: 'um', alvo: detalhamento });
  const handleRemoveGrupoRequest = (grupoNome) => setConfirmDialog({ open: true, tipo: 'grupo', alvo: grupoNome });
  const handleConfirmDialog = () => {
    if (confirmDialog.tipo === 'um' && confirmDialog.alvo) removerProduto(confirmDialog.alvo.produto.uid);
    if (confirmDialog.tipo === 'grupo' && confirmDialog.alvo) removerTodosDoGrupo(confirmDialog.alvo);
    setConfirmDialog({ open: false, tipo: null, alvo: null });
  };
  const handleCancelDialog = () => setConfirmDialog({ open: false, tipo: null, alvo: null });
  const confirmMessage = (() => {
    if (confirmDialog.tipo === 'um' && confirmDialog.alvo)
      return `Deseja remover o produto "${confirmDialog.alvo.produto.nome}"${confirmDialog.alvo.descricaoRodada ? ` (Rodada: ${confirmDialog.alvo.descricaoRodada})` : ''}?`;
    if (confirmDialog.tipo === 'grupo' && confirmDialog.alvo)
      return `Deseja remover TODOS os produtos do grupo "${confirmDialog.alvo}"? Esta ação não poderá ser desfeita.`;
    return '';
  })();

  return (
    <Box>
      <Box
        display="flex"

        alignItems="center"
        flexWrap="wrap"
        mb={2}
        flex={1}
        sx={{
          gap: 1,
          justifyContent: { xs: 'center', sm: 'space-between' }
        }}
      >
        <Typography variant="h6">{label}</Typography>
        <Box display="flex" gap={1}>
          {(exibeLimpar || typeof exibeLimpar !== 'undefined') && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setProdutosSelecionados([])}
            >
              Limpar Produtos
            </Button>
          )}
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setOpenDialog(true)}
          >
            Adicionar Produto
          </Button>
        </Box>
      </Box>

      {(produtosSelecionados && produtosSelecionados.length) ?
        <ProdutoAccordionList
          agrupados={produtosAgrupados}
          onRemover={handleRemoveProductRequest}
          onRemoverGrupo={handleRemoveGrupoRequest}
          permiteEditarDescricao={permiteEditarDescricao}
          field={name}
        />
        :
        (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography sx={{ color: "text.disabled" }}>- {t("NENHUM PRODUTO")} -</Typography>
          </Box>
        )
      }

      <ProdutoSelectorDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        isMobile={isMobile}
        produtosPermitidos={produtosPermitidos}
        produtosSelecionados={produtosSelecionados}
        onAdicionarProdutos={adicionarProdutos}
      />

      <DialogConfirmacao
        open={confirmDialog.open}
        onClose={handleCancelDialog}
        onConfirm={handleConfirmDialog}
      >
        {confirmMessage}
      </DialogConfirmacao>
    </Box>
  );
}